import { render, staticRenderFns } from "./momentsEdit.vue?vue&type=template&id=4615eeec"
import script from "./momentsEdit.vue?vue&type=script&lang=js"
export * from "./momentsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports